import { Divider, styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Form, TextField } from '@app-velocity/ui';

import { useUserData } from '@app-velocity/libs/auth';

import { EmailSection } from '../EmailSection';
import { PasswordSection } from '../PasswordSection';

export const Separator = styled(Divider)(({ theme }) => ({
  margin: `${theme.spacing(5)} 0`,
}));

export const UserDataWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const UserData = () => {
  const { userEmail } = useUserData();
  const { t } = useI18n();

  return (
    <UserDataWrapper>
      <EmailSection>
        <Form.FieldContainer>
          <Form.Label>{t('users:settings.email_address')}</Form.Label>
          <TextField
            name="email"
            defaultValue={userEmail}
            disabled={true}
            fullWidth={true}
          />
        </Form.FieldContainer>
      </EmailSection>
      <Separator />

      <PasswordSection />
    </UserDataWrapper>
  );
}
